import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import stockService from './stockService';

const initialState = {
	// stock: [],
	stockTable: [],
	stockDetailTable: [],
	fetchStock: [],
	allStock:[],
	catalogImages: [],
	deleteCatalogimage: [],
	deleteArticleDesign: [],
	userStock: {},
	data: [],
	Category: [],
	SubCategory: [],
	Product: [],
	Size: [],
	Color: [],
	totalPages: 0,
	isError: false,
	isLoading: false,
	isSuccess: false,
	message: '',
};

// export const getStock = createAsyncThunk('stock/fetchstock', async ({ data, page }, thunkAPI) => {
// 	try {
// 		const response = await stockService.getStock(data, page);
		
// 		return response;
// 	} catch (error) {
// 		const message =
// 			(error.response && error.response.data && error.response.data.message) ||
// 			error.message ||
// 			error.toString();
// 		return thunkAPI.rejectWithValue(message);
// 	}
// });

export const getFetchStock = createAsyncThunk('/getFetchStock', async ({ data, page }, thunkAPI) => {
	try {
		const response = await stockService.getFetchStock(data, page);
		return response;
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString();
		return thunkAPI.rejectWithValue(message);
	}
});

export const getFetchStockTable = createAsyncThunk('/getFetchStockTable', async ({ data, page }, thunkAPI) => {
	try {
		const response = await stockService.getFetchStockTable(data, page);
		return response;
				
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString();
		return thunkAPI.rejectWithValue(message);
	}
});
export const getFetchStockTableForAdmin = createAsyncThunk('/getFetchStockTableForAdmin', async ({ data, page }, thunkAPI) => {
	try {
		const response = await stockService.getFetchStockTableForAdmin(data, page);
		return response;
				
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString();
		return thunkAPI.rejectWithValue(message);
	}
});

export const getFetchStockDetailTable = createAsyncThunk('/getFetchStockDetailTable', async (ProductId, thunkAPI) => {
	try {
		const response = await stockService.getFetchStockDetailTable(ProductId);
		return response;
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString();
		return thunkAPI.rejectWithValue(message);
	}
});
export const getFetchStockDetailTableForAdmin = createAsyncThunk('/getFetchStockDetailTableForAdmin', async (ProductId, thunkAPI) => {
	try {
		const response = await stockService.getFetchStockDetailTableForAdmin(ProductId);
		return response;
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString();
		return thunkAPI.rejectWithValue(message);
	}
});

export const getStockById = createAsyncThunk('/fetchstockbyid', async (id, thunkAPI) => {
	try {
		const response = await stockService.getStockById(id);

		return response;
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString();
		return thunkAPI.rejectWithValue(message);
	}
});
export const getStockByName = createAsyncThunk('/SearchName', async (ProductName, thunkAPI) => {
	try {
		const response = await stockService.getStockByName(ProductName);
		return response;
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString();
		return thunkAPI.rejectWithValue(message);
	}
});

export const getDropdown = createAsyncThunk('/FetchDropdown', async (id, thunkAPI) => {
	try {
		const response = await stockService.getDropdown(id);
		return response;
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString();
		return thunkAPI.rejectWithValue(message);
	}
});
export const getDropdownCategory = createAsyncThunk('/FetchCategory', async (id, thunkAPI) => {
	try {
		const response = await stockService.getDropdownCategory(id);
		return response;
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString();
		return thunkAPI.rejectWithValue(message);
	}
});
export const getDropdownSubCategory = createAsyncThunk('/FetchSubCategory', async (id, thunkAPI) => {
	try {
		const response = await stockService.getDropdownSubCategory(id);
		return response;
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString();
		return thunkAPI.rejectWithValue(message);
	}
});
export const getDropdownProduct = createAsyncThunk('/FetchProduct', async (id, thunkAPI) => {
	try {
		const response = await stockService.getDropdownProduct(id);
		return response;
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString();
		return thunkAPI.rejectWithValue(message);
	}
});
export const getDropdownSize = createAsyncThunk('/FetchSize', async (id, thunkAPI) => {
	try {
		const response = await stockService.getDropdownSize(id);
		return response;
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString();
		return thunkAPI.rejectWithValue(message);
	}
});
export const getDropdownColor = createAsyncThunk('/FetchColor', async (id, thunkAPI) => {
	try {
		const response = await stockService.getDropdownColor(id);
		return response;
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString();
		return thunkAPI.rejectWithValue(message);
	}
});
export const getFetchCatalogImage = createAsyncThunk('/getFetchCatalogImage', async (ProductId, thunkAPI) => {
	try {
		const response = await stockService.getFetchCatalogImage(ProductId);

		return response;
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString();
		return thunkAPI.rejectWithValue(message);
	}
});
export const deleteCatalogImageById = createAsyncThunk('/deleteCatalogImageById', async (Id, thunkAPI) => {
	try {
		const response = await stockService.deleteCatalogImageById(Id);

		return response;
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString();
		return thunkAPI.rejectWithValue(message);
	}
});

export const deleteArticleDesignById = createAsyncThunk('/deleteArticleDesignById', async (Id, thunkAPI) => {
	try {
		const response = await stockService.deleteArticleDesignById(Id);

		return response;
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString();
		return thunkAPI.rejectWithValue(message);
	}
});

const stokeSlice = createSlice({
	name: 'stock',
	initialState,
	reducers: {
		reset: (state) => {
			// state.stock = [];
			state.stockTable = [];
			state.stockDetailTable = [];
			state.fetchStock = [];
			state.allStock = [];
			state.catalogImages = [];
			state.deleteCatalogimage = [];
			state.deleteArticleDesign = [];
			state.userStock = {};
			state.data = [];
			state.Category = [];
			state.SubCategory = [];
			state.Product = [];
			state.Size = [];
			state.Color = [];
			state.isLoading = false;
			state.isError = false;
			state.isSuccess = false;
			state.message = '';
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(getFetchStockTable.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getFetchStockTable.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.stock = action.payload.stock;

				const { currentPage, totalPages, allStock } = action.payload.stock;

				// Append new stock to the existing stock for the current page
				if (state.userStock[currentPage]) {
					// Remove duplicates based on ArticleCode
					const newStock = [
						...state.userStock[currentPage],
						...allStock.filter(
							(item) =>
								!state.userStock[currentPage].some(
									(existingItem) => existingItem.ArticleCode === item.ArticleCode
								)
						),
					];
					state.userStock[currentPage] = newStock;
				} else {
					state.userStock[currentPage] = allStock;
				}

				state.totalPages = totalPages;
				state.message = action.payload.message;
				state.isError = false;
			})
			.addCase(getFetchStockTable.rejected, (state, action) => {
				state.isLoading = false;
				state.isSuccess = false;
				state.isError = true;
				state.message = action.payload;
			})
			.addCase(getFetchStock.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(getFetchStock.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.allStock = action.payload.stock.allStock || []; 
				state.totalPages = action.payload.stock.totalPages;
			})
			.addCase(getFetchStock.rejected, (state, action) => {
				state.isLoading = false;
				state.isError = true;
				state.message = action.payload;
			})
			// -------------------------
			.addCase(getFetchStockTableForAdmin.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(getFetchStockTableForAdmin.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.stockTable = action.payload.stock|| []; 
				
			})
			.addCase(getFetchStockTableForAdmin.rejected, (state, action) => {
				state.isLoading = false;
				state.isError = true;
				state.message = action.payload;
			})
			// ------------------
			.addCase(getFetchStockDetailTable.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getFetchStockDetailTable.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.isError = false;
				state.message = action.payload;
			})
			.addCase(getFetchStockDetailTable.rejected, (state, action) => {
				state.isLoading = false;
				state.isSuccess = false;
				state.isError = true;
				state.message = action.message;
			})
			.addCase(getFetchStockDetailTableForAdmin.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getFetchStockDetailTableForAdmin.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.isError = false;
				state.message = action.payload;
			})
			.addCase(getFetchStockDetailTableForAdmin.rejected, (state, action) => {
				state.isLoading = false;
				state.isSuccess = false;
				state.isError = true;
				state.message = action.message;
			})
		    .addCase(getStockById.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getStockById.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.isError = false;
				state.message = action.payload;
			})
			.addCase(getStockById.rejected, (state, action) => {
				state.isLoading = false;
				state.isSuccess = false;
				state.isError = true;
				state.message = action.payload;
			})
		
			.addCase(getFetchCatalogImage.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getFetchCatalogImage.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.isError = false;
				state.message = action.payload;
			})
			.addCase(getFetchCatalogImage.rejected, (state, action) => {
				state.isLoading = false;
				state.isSuccess = false;
				state.isError = true;
				state.message = action.message;
			})
			.addCase(deleteCatalogImageById.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(deleteCatalogImageById.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.isError = false;
				state.message = action.payload;
			})
			.addCase(deleteCatalogImageById.rejected, (state, action) => {
				state.isLoading = false;
				state.isSuccess = false;
				state.isError = true;
				state.message = action.message;
			})
			.addCase(deleteArticleDesignById.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(deleteArticleDesignById.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.isError = false;
				state.message = action.payload;
			})
			.addCase(deleteArticleDesignById.rejected, (state, action) => {
				state.isLoading = false;
				state.isSuccess = false;
				state.isError = true;
				state.message = action.message;
			})	
			.addCase(getDropdownCategory.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getDropdownCategory.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.Category = action.payload.stock;
				state.isError = false;
			})
			.addCase(getDropdownCategory.rejected, (state, action) => {
				state.isLoading = false;
				state.isSuccess = false;
				state.isError = true;
				state.message = action.payload;
			})
			.addCase(getDropdownSubCategory.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getDropdownSubCategory.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.SubCategory = action.payload.stock;
				state.isError = false;
			})
			.addCase(getDropdownSubCategory.rejected, (state, action) => {
				state.isLoading = false;
				state.isSuccess = false;
				state.isError = true;
				state.message = action.payload;
			})
			.addCase(getDropdownProduct.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getDropdownProduct.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.Product = action.payload.stock;
				state.isError = false;
			})
			.addCase(getDropdownProduct.rejected, (state, action) => {
				state.isLoading = false;
				state.isSuccess = false;
				state.isError = true;
				state.message = action.payload;
			})
			.addCase(getDropdownSize.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getDropdownSize.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.Size = action.payload.stock;
				state.isError = false;
			})
			.addCase(getDropdownSize.rejected, (state, action) => {
				state.isLoading = false;
				state.isSuccess = false;
				state.isError = true;
				state.message = action.payload;
			})
			.addCase(getDropdownColor.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getDropdownColor.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.Color = action.payload.stock;
				state.isError = false;
			})
			.addCase(getDropdownColor.rejected, (state, action) => {
				state.isLoading = false;
				state.isSuccess = false;
				state.isError = true;
				state.message = action.payload;
			})
			.addCase(getDropdown.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getDropdown.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.data = action.payload.stock.stock;
				state.isError = false;
			})
			.addCase(getDropdown.rejected, (state, action) => {
				state.isLoading = false;
				state.isSuccess = false;
				state.isError = true;
				state.message = action.payload;
			});
	},
});

export const { reset, resetMessage } = stokeSlice.actions;
export default stokeSlice.reducer;
